import * as Scrivito from "scrivito";

const Image = Scrivito.provideObjClass("Image", {
  attributes: {
    blob: "binary",
    tags: "stringlist",
    alternativeText: "string",
    description: "html",
    title: "string",
  },
});

export default Image;
